/**
 * getQuestions.js
 * Written by: Alex Kasemir
 */
import request from '../../../request/actions';

export const GET_QUESTIONS_START = `GET_QUESTIONS_START`;
export const GET_QUESTIONS_SUCCESS = `GET_QUESTIONS_SUCCESS`;
export const GET_QUESTIONS_FAILURE = `GET_QUESTIONS_FAILURE`;

export const getQuestionsStart = () => ({
  type: GET_QUESTIONS_START,
});

export const getQuestionsSuccess = (questions) => ({
  type: GET_QUESTIONS_SUCCESS,
  questions,
});

export const getQuestionsFailure = (error) => ({
  type: GET_QUESTIONS_FAILURE,
  error,
});

/**
 * getting questions for a given quiz
 */
export const getQuestions = (id) => {
  return (dispatch) => {
    dispatch(getQuestionsStart());

    return new Promise((resolve, reject) => {
      dispatch(request(`/quizzes/${id}/questions`, `GET`))
        .then((response) => {
          dispatch(getQuestionsSuccess(response.data.results));
          resolve();
        })
        .catch((error) => {
          dispatch(getQuestionsFailure(error));
          reject();
        });
    });
  };
};
